import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '500px',
    minWidth: '500px',
    [theme.breakpoints.down('xs')]: {
      minHeight: 'unset',
      minWidth: 'unset',
    },
  },
  embeddedRoot: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  titleFont: {
    fontSize: '16px',
    color: theme.palette.text.secondary,
    fontWeight: 900,
  },
  titleWrapper: {
    margin: '20px 0 32px 0',
  },
  headerFont: {
    fontSize: '30px',
    fontWeight: 900,
  },
  statsSection: {
    width: '100%',
    maxWidth: 520,
    margin: '0 auto',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },
  statsGrid: {
    width: '100%',
    margin: 0,
  },
  statsGridItem: {
    display: 'flex',
  },
  statCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    width: '100%',
    minWidth: 0,
    minHeight: 108,
    backgroundColor: theme.palette.common.white,
    boxShadow: '0 1px 3px rgba(0, 35, 75, 0.08)',
  },
  statLabel: {
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    display: 'block',
    width: '100%',
  },
  statValue: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#001C57',
    lineHeight: 1.2,
    display: 'block',
    width: '100%',
  },
  statBadgeSpacer: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    marginTop: 'auto',
    paddingTop: theme.spacing(0.5),
  },
  statBadge: {
    backgroundColor: '#EBF0F2 !important',
    border: 'none',
    height: 24,
  },
  statBadgeLabel: {
    color: '#172024 !important',
    fontWeight: 500,
    fontSize: '0.8125rem',
  },
  feedbackRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(3),
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    fontSize: '0.875rem',
    '&:hover': {
      color: theme.palette.primary.main,
    },
    '& svg, & .MuiSvgIcon-root': {
      width: 18,
      height: 18,
      fontSize: 18,
    },
  },
}))
